import { MenuItem, TreeNode, Menu } from '~/types/Menu';

export const transformMenuItem = (
  menuItem: MenuItem,
  children: TreeNode[] | undefined,
  parentId: string,
  isLoading: boolean = false
): TreeNode => {
  return {
    ...menuItem,
    name: menuItem?.fallbackName ?? menuItem?.code ?? 'Unknown',
    type: menuItem?.itemType.toLowerCase() as any,
    branding: menuItem?.branding
      ? {
          ...menuItem?.branding,
          icon: menuItem?.branding?.icon
            ? { id: menuItem?.branding?.icon, mimeType: 'image' }
            : menuItem?.branding?.icon,
        }
      : undefined,
    children,
    parentId,
    isLoading,
  };
};

// Helper function to recursively collect all descendant IDs
export const getDescendantIds = (node: TreeNode): string[] => {
  let ids: string[] = [];
  if (node.children) {
    for (const child of node.children) {
      ids.push(child.id);
      ids = ids.concat(getDescendantIds(child));
    }
  }
  return ids;
};

export const findNodeById = (nodes: TreeNode[], id: string): TreeNode | null => {
  for (const node of nodes) {
    if (node.id === id) return node;
    if (node.children) {
      const childNode = findNodeById(node.children, id);
      if (childNode) return childNode;
    }
  }
  return null;
};

export const initializeTreeData = (
  menuRecord: Menu,
  initialChildren: TreeNode[] | undefined,
  isChildrenLoading: boolean
): TreeNode[] => {
  //   const initialChildren = children?.map((child: MenuItem) =>
  //     transformMenuItem(
  //       child,
  //       child?.itemType === 'GROUP' ? [] : undefined,
  //       menuRecord?.id,
  //       isChildrenLoading
  //     )
  //   );
  return [
    {
      ...menuRecord,
      type: 'menu',
      children: initialChildren || [],
      isLoading: isChildrenLoading,
    },
  ];
};

export const isNodeExpandable = (node: TreeNode): boolean => {
  return node.type === 'menu' || node.type === 'group';
};
